
export const hashReducer = (state = '', action) => {
  switch (action.type) {
    case 'SET_HASH':
      return action.hash;
    default:
      return state;
  }
};

export const originReducer = (state = '', action) => {
  switch (action.type) {
    case 'SET_ORIGIN':
      return action.origin;
    default:
      return state;
  }
};

export const variantReducer = (state = '', action) => {
  switch (action.type) {
    case 'SET_VARIANT':
      return action.variant;
    default:
      return state;
  }
};

export const sessionIDReducer = (state = '', action) => {
  switch (action.type) {
    case 'SET_SESSION_ID':
      return action.sessionID;
    default:
      return state;
  }
};

export const productIDReducer = (state = '', action) => {
  switch (action.type) {
    case 'SET_PRODUCT_ID':
      return action.product_id;
    default:
      return state;
  }
};

export const referrerReducer = (state = '', action) => {
  switch (action.type) {
    case 'SET_REFERRER':
      return action.referrer;
    default:
      return state;
  }
};
